exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host .section-header {\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 17.6px;\n  padding-top: 0.5rem;\n  padding-right: 0;\n  padding-bottom: 0.5rem;\n  padding-left: 0;\n  margin-bottom: .5rem;\n  display: block;\n  border-bottom: 1px dashed #d4d4d4; }\n\n:host .row-buttons {\n  margin-top: .5rem; }\n\n:host .add-button-div {\n  padding-left: 0;\n  margin-top: .5rem; }\n\n:host ::ng-deep .control-label {\n  text-align: right;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/ggw-dynamic-route-template-form.component.scss
// module id = ../../../../../src/app/modules/models/ggw-dynamic-routes/components/ggw-dynamic-route-template-form/ggw-dynamic-route-template-form.component.scss
// module chunks = main